function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { localStorageSetItem, localStorageGetItem } from "../../utils/useLocalStorage.js";
import isAppRouteContext from "./isAppRouteContext";
import BlocketLogoLink from "./BlocketLogoLink";
import BigAssCategoryPicker from "./BigAssCategoryPicker";
import ColorBar from "./ColorBar";
import Links from "./Links";
import * as TabBarUI from "./TabBar.styles";

function TabBar(_ref) {
  var adInsertUrl = _ref.adInsertUrl,
      adsUrl = _ref.adsUrl,
      adWatchesNewCount = _ref.adWatchesNewCount,
      bigAssCategories = _ref.bigAssCategories,
      isAppRoute = _ref.isAppRoute,
      linkComponent = _ref.linkComponent,
      onAdInsertClick = _ref.onAdInsertClick,
      onLoginClick = _ref.onLoginClick,
      pathname = _ref.pathname,
      _ref$showAdwatchesCou = _ref.showAdwatchesCounter,
      showAdwatchesCounter = _ref$showAdwatchesCou === void 0 ? false : _ref$showAdwatchesCou,
      trackBigAssCategoryClick = _ref.trackBigAssCategoryClick,
      trackBigAssCategoryOpenMenuClick = _ref.trackBigAssCategoryOpenMenuClick,
      unreadMessagesCount = _ref.unreadMessagesCount,
      userInfo = _ref.userInfo,
      tooltipInfo = _ref.tooltipInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  var localStorageKey = tooltipInfo && tooltipInfo.localStorageId;

  var onBigAssCategoryClick = function onBigAssCategoryClick(categoryName) {
    if (trackBigAssCategoryClick) {
      trackBigAssCategoryClick(categoryName);
    }
  };

  var onCategoriesButtonClick = function onCategoriesButtonClick() {
    if (trackBigAssCategoryOpenMenuClick) {
      trackBigAssCategoryOpenMenuClick();
    }
  };

  var onTooltipClose = function onTooltipClose() {
    setShowTooltip(false);

    if (localStorageKey) {
      localStorageSetItem(localStorageKey, true);
    }
  };

  useEffect(function () {
    if (tooltipInfo && localStorageKey) {
      var tooltipHasBeenShown = localStorageGetItem(localStorageKey);

      if (!tooltipHasBeenShown) {
        setShowTooltip(true);
      }
    }
  }, [showTooltip, tooltipInfo, localStorageKey]);
  return /*#__PURE__*/React.createElement(TabBarUI.Root, {
    "data-cy": "main-navigation"
  }, /*#__PURE__*/React.createElement(ColorBar, null), /*#__PURE__*/React.createElement(isAppRouteContext.Provider, {
    value: {
      isAppRoute: isAppRoute,
      linkComponent: linkComponent
    }
  }, /*#__PURE__*/React.createElement(TabBarUI.NavBar, null, /*#__PURE__*/React.createElement(TabBarUI.Item, {
    grow: !bigAssCategories
  }, /*#__PURE__*/React.createElement(BlocketLogoLink, {
    href: "/",
    text: "logo",
    "aria-label": "G\xE5 till huvudsidan"
  })), bigAssCategories && /*#__PURE__*/React.createElement(TabBarUI.Item, {
    grow: true,
    hideOnNarrowScreens: true
  }, /*#__PURE__*/React.createElement(BigAssCategoryPicker, {
    linkComponent: linkComponent,
    categories: bigAssCategories,
    onCategoriesButtonClick: onCategoriesButtonClick,
    onCategoryClick: onBigAssCategoryClick
  })), /*#__PURE__*/React.createElement(TabBarUI.Item, {
    hideOnNarrowScreens: true
  }, /*#__PURE__*/React.createElement(Links.NewAdButton, {
    adInsertUrl: adInsertUrl
  })), /*#__PURE__*/React.createElement(TabBarUI.Item, null, /*#__PURE__*/React.createElement(Links.Ads, {
    adsUrl: adsUrl,
    pathname: pathname,
    tooltipInfo: showTooltip && tooltipInfo.type === 'ads' ? tooltipInfo : undefined,
    tooltipCloseAction: onTooltipClose
  })), /*#__PURE__*/React.createElement(TabBarUI.Item, {
    hideOnWideScreens: true
  }, /*#__PURE__*/React.createElement(Links.NewAd, {
    adInsertUrl: adInsertUrl,
    onAdInsertClick: onAdInsertClick,
    pathname: pathname
  })), /*#__PURE__*/React.createElement(TabBarUI.Item, null, /*#__PURE__*/React.createElement(Links.Messaging, {
    unreadMessagesCount: unreadMessagesCount,
    pathname: pathname,
    tooltipInfo: showTooltip && tooltipInfo.type === 'messaging' ? tooltipInfo : undefined,
    tooltipCloseAction: onTooltipClose
  })), /*#__PURE__*/React.createElement(TabBarUI.Item, null, /*#__PURE__*/React.createElement(Links.Saved, {
    adWatchesNewCount: adWatchesNewCount,
    showAdwatchesCounter: showAdwatchesCounter,
    pathname: pathname,
    tooltipInfo: showTooltip && tooltipInfo.type === 'saved' ? tooltipInfo : undefined,
    tooltipCloseAction: onTooltipClose
  })), /*#__PURE__*/React.createElement(TabBarUI.Item, null, /*#__PURE__*/React.createElement(Links.Profile, {
    userInfo: userInfo,
    onLoginClick: onLoginClick,
    pathname: pathname,
    tooltipInfo: showTooltip && tooltipInfo.type === 'profile' ? tooltipInfo : undefined,
    tooltipCloseAction: onTooltipClose
  })))));
}

TabBar.propTypes = process.env.NODE_ENV !== "production" ? {
  userInfo: PropTypes.shape({
    loggedIn: PropTypes.bool,
    displayNames: PropTypes.shape({
      spid: PropTypes.string
    })
  }),

  /**
   * Click event handler for the login link
   */
  onLoginClick: PropTypes.func.isRequired,

  /**
   * Number of unread messages
   */
  unreadMessagesCount: PropTypes.number,

  /**
   * Number of new ads in ad-watches
   */
  adWatchesNewCount: PropTypes.number,

  /**
   * function(path) that returns true or false depending on if the given path exists in the current SPA.
   */
  isAppRoute: PropTypes.func.isRequired,

  /**
   * Path to /annonser with an appropriate query string
   */
  adsUrl: PropTypes.string.isRequired,

  /**
   * Ad insert url
   */
  adInsertUrl: PropTypes.string.isRequired,

  /**
   * Optional callback for the ad insert link
   */
  onAdInsertClick: PropTypes.func,

  /**
   * Used by BigAssCategoryPicker if user clicks link in category menu
   */
  trackBigAssCategoryClick: PropTypes.func,

  /**
   * Used by BigAssCategoryPicker if user open category menu
   */
  trackBigAssCategoryOpenMenuClick: PropTypes.func,

  /**
   * Categories to show in BigAssCategory Menu
   */
  bigAssCategories: PropTypes.array,

  /**
   * Show the actual number of notifications instead of the circle
   */
  showAdwatchesCounter: PropTypes.bool,

  /**
   * Link Component to handle route navigations, fallbacks to <a> tag
   */
  linkComponent: PropTypes.elementType,

  /**
   * Apps current pathname
   */
  pathname: PropTypes.string.isRequired,

  /**
   * Optional - data with tooltip info. If this is not sent, the tooltip will not be shown.
   * ***type*** should match the TabBarLink that you wish to render the ToolTip for (eg. 'ads' | 'messaging' | 'saved' | 'profile')
   * ***localStorageId*** should be named in a unique way (allthogh same for all SPAs) that matches the Tooltip purpose.
   * The logic is to show the tooltip once to the user and never show it again after close or call to action.
   */
  tooltipInfo: PropTypes.shape({
    type: PropTypes.string,
    localStorageId: PropTypes.string,
    heading: PropTypes.string.isRequired,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonOnClick: PropTypes.func,
    imgSrc: PropTypes.string
  })
} : {};
export default TabBar;
//# sourceMappingURL=TabBar.js.map